function isAppProduction(): boolean {
  return process.env.NEXT_PUBLIC_ENVIRONMENT === 'production'
}

export default isAppProduction
